<template>
  <div class="scroll-vertical">
    <detail-item
      name="Event Timestamp"
      imgName="circle">
      {{ event.timestamp | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="Path"
      imgName="circle">
      {{ event.path }}
    </detail-item>
  </div>
</template>

<script>
import gmt from '@/mixins/gmt';
import events from '@/mixins/events';
import DetailItem from '@/components/DetailItem.vue';

export default {
  name: 'GPScreenshotEvent',
  mixins: [events, gmt],
  components: { DetailItem },
  props: {
    event: {
      type: Object,
      required: true,
    },
    related: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      def: this.$typeDefs.events.GPScreenshotEvent,
    };
  },
};
</script>
